import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { SaleOrder } from '../point-of-sale/domain/SaleOrder';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-sale-orders',
  templateUrl: './sale-orders.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./sale-orders.component.css']
})
export class SaleOrdersComponent implements OnInit {
  @ViewChild("searchOrder", { static: false }) searchOrderInput: ElementRef;
  loading: boolean;
  user: IUser;
  saleOrder: SaleOrder;
  first: number = 0;
  tabIndex: number = 0;

  sales: any[];
  sourceSales: any[];

  deliverySales: any[];
  sourceDeliverySales: any[];

  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private loader: NgxSpinnerService

  ) {
    this.breadcrumbService.setItems([
      { label: 'Sales' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("SaleOrdersComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.saleOrder = new SaleOrder();
    this.getSales();
    this.sales = [];
  }

  ngAfterViewInit() {
    this.searchOrderInput.nativeElement.focus();

  }

  getSales() {
    this.loading = true;
    this.loader.show();
    this.appServiceManager.get(`products/salesorders/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {

        this.sales = res.filter(x => x.status == 'POS');
        this.sourceSales = this.sales;
        this.sourceSales = this.sourceSales.sort((a, b) => { return <any>new Date(b.invoiceDate) - <any>new Date(a.invoiceDate) });

        this.deliverySales = res.filter(x => x.status != 'POS');
        this.sourceDeliverySales = this.deliverySales;

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
      this.loader.hide();
    },
      (error) => {
        this.loading = false;
        this.loader.hide();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  //Status based filtering
  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      this.clearSearchDeliveryOrders();
    }
    if (index == 1) {
      this.tabIndex = 1;
      this.clear();
    }

  }

  searchLocal(value, type) {
    let matchedNumber = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.sales = Object.assign([], this.sourceSales);
      }
      if (!value) {
        this.sales = Object.assign([], this.sourceSales);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = Object.assign([], this.sourceSales).filter(
            cust => cust.invoiceNumber ? cust.invoiceNumber.indexOf(value) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.sales = source.filter(distinct);

        if (this.sales.length === 0) {
          this.sales = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.sales.length === 1) {
            this.first = 0;
          }
          this.sales = [...this.sales];
        }
      }
    } else {
      this.sales = Object.assign([], this.sourceSales);
      this.sales = [...this.sales];
    }
  }

  clear() {
    this.saleOrder = new SaleOrder();
    this.searchLocal("", "");
    this.first = 0;
  }

  searchLocalDeliveryOrders(value, type) {
    let matchedNumber = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.deliverySales = Object.assign([], this.sourceDeliverySales);
      }
      if (!value) {
        this.deliverySales = Object.assign([], this.sourceDeliverySales);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = Object.assign([], this.sourceDeliverySales).filter(
            cust => cust.invoiceNumber ? cust.invoiceNumber.indexOf(value) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.deliverySales = source.filter(distinct);

        if (this.deliverySales.length === 0) {
          this.deliverySales = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.deliverySales.length === 1) {
            this.first = 0;
          }
          this.deliverySales = [...this.deliverySales];
        }
      }
    } else {
      this.deliverySales = Object.assign([], this.sourceDeliverySales);
      this.deliverySales = [...this.deliverySales];
    }
  }

  clearSearchDeliveryOrders() {
    this.saleOrder = new SaleOrder();
    this.searchLocalDeliveryOrders("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/point-of-sale");

    }
  }

  viewSaleOrder(order) {
    this.route.navigateByUrl('point-of-sale/' + order._id);
  }



}
